import ApiService from '@/services/ApiService';

const namespace = 'vat';

const check = (options, callback, errorCallback) => {
    ApiService.post(`${namespace}/check`, options, callback, errorCallback);
};

export default {
    check,
};



// WEBPACK FOOTER //
// ./src/taskflex/customers/services/VatService.js